import { render, staticRenderFns } from "./RateioValorContrato.vue?vue&type=template&id=1077ffcc&"
import script from "./RateioValorContrato.vue?vue&type=script&lang=js&"
export * from "./RateioValorContrato.vue?vue&type=script&lang=js&"
import style0 from "./RateioValorContrato.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports